// components/Accordion.js
import { useState } from 'react';

export default function Accordion({ title = 'הסבר', content, className = '' }) {
  const [isOpen, setIsOpen] = useState(false);

  // Don't render if content is empty
  if (!content || content.trim() === '') {
    return null;
  }

  return (
    <div className={`border border-secondary-200 dark:border-secondary-700 rounded-lg overflow-hidden ${className}`}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 bg-secondary-50 dark:bg-secondary-800 hover:bg-secondary-100 dark:hover:bg-secondary-750 transition-colors"
        aria-expanded={isOpen}
      >
        <span className="font-semibold text-secondary-900 dark:text-white flex items-center gap-2">
          <svg className="w-5 h-5 text-primary-600 dark:text-primary-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {title}
        </span>
        <svg
          className={`w-5 h-5 text-secondary-600 dark:text-secondary-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="p-4 bg-white dark:bg-secondary-900 border-t border-secondary-200 dark:border-secondary-700">
          <p className="text-secondary-700 dark:text-secondary-300 whitespace-pre-wrap leading-relaxed">
            {content}
          </p>
        </div>
      )}
    </div>
  );
}
